import React, { useEffect, useState } from 'react';
import {
    airlineImageFn,
    convertMinutesFn, formatDateMonthWise,
    formatDateTime,
    formatPrice,
    getDateDifference,
    formatePriceFn
} from "../../../helper/commonFunction";
import { ChevronDownIcon, ChevronUpIcon, FlightIcon, FlightSeatIcon, FlightSeatCurrentColorIcon } from "../../../helper/HwIcon";

const FlightsShowComponent = ({flights, flightTabChangeFn, setViewFaresDataFn, agentActiveCurrency, index,queryParams, openFareViews, openDetailsViews,showVendorLogo, seatShow, lowPrice,displayPrice}) => {
    const [flightLoadLoader , setFlightLoadLoader] = useState(true);
    const seatRemaining = flights?.pricing?.[0]?.seatRemaining;
    const seatRemainingCount = Number(seatRemaining);
    const hasValidSeatCount = Number.isFinite(seatRemainingCount) && seatRemainingCount > 0;
    const shouldShowSeatRemaining = !!seatShow && hasValidSeatCount;
    const seatAvailabilityText = seatRemainingCount === 1
        ? 'only 1 seat left'
        : seatRemainingCount >= 2 && seatRemainingCount <= 8
            ? `${seatRemainingCount} seats left`
            : '9+ seats left';
    const seatAvailabilityStyle = seatRemainingCount === 1
        ? { color: '#e3342f', backgroundColor: '#fff1f2' }
        : seatRemainingCount >= 9
            ? { color: '#1f8f4a', backgroundColor: '#effaf3' }
            : { color: '#f08c00', backgroundColor: '#fff7eb' };

    const renderSeatLeftBadge = () => {
        if (!shouldShowSeatRemaining) return null;

        return (
            <div
                className="hw-text14 hw-fontWeight--500 mt-1"
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    borderRadius: "999px",
                    padding: "0.5rem 1rem",
                    marginRight: "0",
                    marginLeft: "0",
                    lineHeight: 1,
                    ...seatAvailabilityStyle
                }}
            >
                <span className="d-flex align-items-center hw-gapy4">
                    <FlightSeatCurrentColorIcon />
                    <span>{seatAvailabilityText}</span>
                </span>
            </div>
        );
    };
    const [flightDetails, setFlightDetails] = useState({
        departureFlights: [],
        returnFlights: [],
        multiCityData: {},
        departureDuration: 0,
        returnDuration: 0
    })


    useEffect(() => {
        if (flights?.segments?.length && flights?.tripType === 'COMBO') {
            if (Array.isArray(queryParams?.segments)) {
                let multiCityData = {};
                queryParams?.segments?.forEach((segment, segmentIndex) => {
                    const { fromAirport, toAirport, departDate } = segment;
                    let matchedFlights = [];
                    let collecting = false;
                    let totalDuration = 0;
                    for (const flight of flights?.segments || []) {
                        const flightDepartureDate = flight?.departure?.departureTime?.split("T")[0];
                        if ((flight.departure.airportCode === fromAirport || flight?.neareastFromAirport === fromAirport) && flightDepartureDate === departDate) {
                            collecting = true;
                        }
                        if (collecting) {
                            matchedFlights.push(flight);
                            totalDuration += (flight.duration || 0) + (flight.connectingTime || 0);

                            if (flight.arrival.airportCode === toAirport || flight?.neareastToAirport === toAirport) {
                                break;
                            }
                        }
                    }

                    if (flights?.source === 'amadeus') {
                        totalDuration = matchedFlights?.[0]?.amadeusDurations || 0
                    }

                    if (matchedFlights.length) {
                        multiCityData[segmentIndex] = {
                            flights: matchedFlights,
                            source: flights?.source,
                            totalDuration
                        };
                    }
                });

                setFlightDetails({
                    ...flightDetails,
                    multiCityData: multiCityData,
                });
            } else {
                const departureFlights = [];
                const returnFlights = [];
                let multiCityData = {}
                let departureDuration = 0, returnDuration = 0;
                let isDeparture = true;
                for (const flight of flights?.segments) {
                    if (isDeparture) {
                        departureFlights.push(flight);
                        if (flight.arrival.airportCode === queryParams?.toAirport || flight?.neareastToAirport === queryParams?.toAirport) {
                            isDeparture = false;
                        }
                    } else {
                        returnFlights.push(flight);
                    }
                }
                if (departureFlights?.length) {
                    departureFlights?.map((flight) => {
                        let connectingtime = flight?.connectingTime || 0;
                        let duration = flight?.duration || 0;
                        departureDuration += (connectingtime + duration);
                    })
                    if (flights?.source === 'amadeus') {
                        departureDuration = departureFlights?.[0]?.amadeusDurations || 0
                    }
                }
                if (returnFlights?.length) {
                    returnFlights?.map((flight) => {
                        let connectingtime = flight?.connectingTime || 0;
                        let duration = flight?.duration || 0;
                        returnDuration += (connectingtime + duration);
                    })
                    if (flights?.source === 'amadeus') {
                        returnDuration = returnFlights?.[0]?.amadeusDurations || 0
                    }
                }

                setFlightDetails({
                    departureFlights,
                    returnFlights,
                    departureDuration,
                    returnDuration,
                    multiCityData
                })
            }
            setFlightLoadLoader(false);
        }
    }, [flights])

    return (
        <>
            {flights?.tripType === 'COMBO' ? <> {flightLoadLoader ? <div className="hw-flight--listBox align-items-center hw-main--loaderCommon" /> : <>
                <div className="hw-flight--listBox align-items-center pl-null">
                    <div className="hw-flight--listBoxInner hw-mlCity">
                        {Object?.keys(flightDetails?.multiCityData)?.length ? Object?.keys(flightDetails?.multiCityData)?.map((flightIndex,keyIndex) => {
                            let flightData = flightDetails?.multiCityData?.[flightIndex];
                            let flights = flightData?.flights;
                            return (
                                <>
                                    <div className="hw-flight--listBoxInnerList">
                                        <div className="hw-search--flightFilterResult__listItemList d-flex align-items-center hw-gapy10">
                                            {[...new Set(flights?.map((segment) => segment?.flightCode))]?.map((flightCode, airlineIndex) => {
                                                const segment = flights?.find((seg) => seg?.flightCode === flightCode);
                                                return (
                                                    <span key={airlineIndex} className="hw-text14 d-flex align-items-center hw-gapy10">
                                                        <img
                                                            width={40}
                                                            height={40}
                                                            src={airlineImageFn(segment?.flightCode)}
                                                            alt={segment?.flightName}
                                                        />
                                                        <div className='d-flex d-flex-column'>
                                                            <span className='hw-blue hw-fontBold hw-text--100ellipsis'>{segment?.flightName}</span>
                                                            <span className='hw-text12 hw-grayk500'>{segment?.flightCode}{segment?.flightNumber}</span>
                                                        </div>

                                                    </span>
                                                );
                                            })}
                                            {(showVendorLogo && keyIndex === 0) ? <div className="hw-text14 d-flex hw-gapy10 hw--vendor-img ml-auto" style={{position : "absolute", right : 0}}>
                                                <span className="hw-text14 hw-fontBold d-flex hw-gapy10"> {flightData?.source?.replace(/-/g, '')?.replace(/^./, c => c?.toUpperCase())}</span>
                                            </div> : null}
                                        </div>
                                        <div className="destination ss">
                                           <div className='destination-from'>


                                                <div className="hw-text18 hw-fontBold hw-blue">{formatDateTime(flights?.[0]?.departure?.departureTime)?.time}</div>
                                                <div className="hw-text14 hw-black900 hw-fontWeight--500">{flights?.[0]?.departure?.city}</div>
                                               <div className="hw-text14 hw-black500 hw-fontWeight--500">{formatDateMonthWise(flights?.[0]?.departure?.departureTime)}</div>
                                                {/* <div className="hw-text14">{formatDateTime(flights?.[0]?.departure?.departureTime)?.date}</div> */}
                                            </div>
                                            <div className="hw-flight--listBox__flight">

                                                <span className="hw-fontWeight--500 hw-black900">{convertMinutesFn(flightData?.totalDuration)}</span>
                                                <div className="hw-flight--line">
                                                     {flights?.map((segement,segementIndex) => {
                                                        if(segementIndex !== 0){
                                                            return (
                                                                <span
                                                                  className={`hw-flight--line--stop ${segementIndex === 1 ? 'hw-linestop1' : 'hw-linestopfull'}`}
                                                                 />
                                                            )
                                                        }
                                                    })}
                                                    <span className="circle" /><span className="line" /><span className="circle" /></div>

                                                <span className="hw-text14 hw-fontWeight--500">{flights?.length === 1 ? 'Non-Stop' : `${flights?.length - 1} stop`}</span>
                                            </div>
                                            <div className='destination-to'>

                                                <div className="hw-text18 hw-fontBold hw-blue">{formatDateTime(flights?.[flights?.length - 1]?.arrival?.arrivalTime)?.time}</div>
                                                <div className="hw-text14 hw-black900 hw-fontWeight--500">{flights?.[flights?.length - 1]?.arrival?.city}</div>
                                                <div className="hw-text14 hw-black500 hw-fontWeight--500">{formatDateMonthWise(flights?.[flights?.length - 1]?.arrival?.arrivalTime)}</div>
                                                {/* <div className="hw-text14">{formatDateTime(flights?.[flights?.length - 1]?.arrival?.arrivalTime)?.date}</div> */}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        })
                            :
                            <>
                                {flightDetails?.departureFlights?.length ?
                                    <div className="hw-flight--listBoxInnerList">
                                        <div className="hw-search--flightFilterResult__listItemList d-flex align-items-center hw-gapy10">
                                            {[...new Set(flightDetails?.departureFlights?.map((segment) => segment?.flightCode))]?.map((flightCode, airlineIndex) => {
                                                const segment = flightDetails?.departureFlights?.find((seg) => seg?.flightCode === flightCode); // Retrieve the corresponding segment
                                                return (
                                                    <span key={airlineIndex} className="hw-text14 d-flex align-items-center hw-gapy10">
                                                        <img
                                                            width={40}
                                                            height={40}
                                                            src={airlineImageFn(segment?.flightCode)}
                                                            alt={segment?.flightName}
                                                        />
                                                        <div className='d-flex d-flex-column'>
                                                            <span className='hw-blue hw-fontBold hw-text--100ellipsis'>{segment?.flightName}</span>
                                                            <span className='hw-text12 hw-grayk500'>{segment?.flightCode}{segment?.flightNumber}</span>
                                                        </div>
                                                    </span>
                                                );
                                            })}
                                            {showVendorLogo ? <div className="hw-text14 d-flex hw-gapy10 hw--vendor-img ml-auto" style={{position : "absolute", right : 0}}>
                                                <span className="hw-text14 hw-fontBold d-flex hw-gapy10"> {flights?.source?.replace(/-/g, '')?.replace(/^./, c => c?.toUpperCase())}</span>

                                            </div>
                                                : null}
                                        </div>
                                        <div className="destination s2">
                                            <div className='destination-from'>
                                                <div className="hw-text14 hw-black900 hw-fontWeight--500">{flightDetails?.departureFlights?.[0]?.departure?.city}</div>
                                                 <div className="hw-text18 hw-fontBold hw-blue">{formatDateTime(flightDetails?.departureFlights?.[0]?.departure?.departureTime)?.time}</div>
                                                <div className="hw-text14 hw-black500 hw-fontWeight--500">{formatDateMonthWise(flightDetails?.departureFlights?.[0]?.departure?.departureTime)}</div>
                                                {/* <div className="hw-text14">{formatDateTime(flightDetails?.departureFlights?.[0]?.departure?.departureTime)?.date}</div> */}
                                            </div>

                                            <div className="hw-flight--listBox__flight">

                                                <span className="hw-fontWeight--500 hw-black900">{convertMinutesFn(flightDetails?.departureDuration)}</span>
                                                <div className="hw-flight--line">
                                                    {flightDetails?.departureFlights?.map((segement,segementIndex) => {
                                                        if(segementIndex !== 0){
                                                            return (
                                                                <span
  className={`hw-flight--line--stop ${segementIndex === 1 ? 'hw-linestop1' : 'hw-linestopfull'}`}
 />
                                                            )
                                                        }
                                                    })}
                                                    <span className="circle" /><span className="line" /><span className="circle" /></div>
                                                <span className="hw-text14 hw-fontWeight--500">{flightDetails?.departureFlights?.length === 1 ? 'Non-Stop' : `${flightDetails?.departureFlights?.length - 1} stop`}</span>
                                            </div>
                                            <div className='destination-to'>
                                                <div className="hw-text14 hw-black900 hw-fontWeight--500">{flightDetails?.departureFlights[flightDetails?.departureFlights?.length - 1]?.arrival?.city}</div>
                                                <div className="hw-text18 hw-fontBold hw-blue">{formatDateTime(flightDetails?.departureFlights[flightDetails?.departureFlights?.length - 1]?.arrival?.arrivalTime)?.time}</div>
                                                <div className="hw-text14 hw-black500 hw-fontWeight--500">{formatDateMonthWise(flightDetails?.departureFlights[flightDetails?.departureFlights?.length - 1]?.arrival?.arrivalTime)}</div>
                                                {/* <div className="hw-text14">{formatDateTime(flightDetails?.departureFlights[flightDetails?.departureFlights?.length - 1]?.arrival?.arrivalTime)?.date}</div> */}
                                            </div>
                                        </div>
                                    </div>
                                    : null}
                                {flightDetails?.returnFlights?.length ?
                                    <div className="hw-flight--listBoxInnerList">
                                        <div className="hw-search--flightFilterResult__listItemList d-flex align-items-center hw-gapy10">
                                            {[...new Set(flightDetails?.returnFlights?.map((segment) => segment?.flightCode))]?.map((flightCode, airlineIndex) => {
                                                const segment = flightDetails?.returnFlights?.find((seg) => seg?.flightCode === flightCode); // Retrieve the corresponding segment
                                                return (
                                                    <span key={airlineIndex} className="hw-text14 d-flex align-items-center hw-gapy10">
                                                        <img
                                                            width={40}
                                                            height={40}
                                                            src={airlineImageFn(segment?.flightCode)}
                                                            alt={segment?.flightName}
                                                        />
                                                        <div className='d-flex d-flex-column'>
                                                            <span className='hw-blue hw-fontBold hw-text--100ellipsis'>{segment?.flightName}</span>
                                                            <span className='hw-text12 hw-grayk500'>{segment?.flightCode}{segment?.flightNumber}</span>
                                                        </div>
                                                    </span>
                                                );
                                            })}
                                        </div>
                                        <div className="destination s3">
                                            <div className='destination-from'>

                                                <div className="hw-text18 hw-fontBold hw-blue">{formatDateTime(flightDetails?.returnFlights?.[0]?.departure?.departureTime)?.time}</div>
                                                <div className="hw-text14 hw-black900 hw-fontWeight--500">{flightDetails?.returnFlights?.[0]?.departure?.city}</div>
                                                <div className="hw-text14 hw-black500 hw-fontWeight--500">{formatDateMonthWise(flightDetails?.returnFlights?.[0]?.departure?.departureTime)}</div>
                                                {/* <div className="hw-text14">{formatDateTime(flightDetails?.returnFlights?.[0]?.departure?.departureTime)?.date}</div> */}
                                            </div>
                                            <div className="hw-flight--listBox__flight">

                                                <span className="hw-fontWeight--500 hw-black900">{convertMinutesFn(flightDetails?.returnDuration)}</span>
                                                <div className="hw-flight--line">
                                                    {flightDetails?.returnFlights?.map((segement,segementIndex) => {
                                                        if(segementIndex !== 0){
                                                            return (
                                                               <span
  className={`hw-flight--line--stop ${segementIndex === 1 ? 'hw-linestop1' : 'hw-linestopfull'}`}
 />
                                                            )
                                                        }
                                                    })}
                                                    <span className="circle" /><span className="line" /><span className="circle" /></div>
                                                <span className="hw-text14 hw-fontWeight--500">{flightDetails?.returnFlights?.length === 1 ? 'Non-Stop' : `${flightDetails?.returnFlights?.length - 1} stop`}</span>
                                            </div>
                                           <div className='destination-to'>

                                                <div className="hw-text18 hw-fontBold hw-blue">{formatDateTime(flightDetails?.returnFlights[flightDetails?.returnFlights?.length - 1]?.arrival?.arrivalTime)?.time}</div>
                                                <div className="hw-text14 hw-black900 hw-fontWeight--500">{flightDetails?.returnFlights[flightDetails?.returnFlights?.length - 1]?.arrival?.city}</div>
                                               <div className="hw-text14 hw-black500 hw-fontWeight--500">{formatDateMonthWise(flightDetails?.returnFlights[flightDetails?.returnFlights?.length - 1]?.arrival?.arrivalTime)}</div>
                                                {/* <div className="hw-text14">{formatDateTime(flightDetails?.returnFlights[flightDetails?.returnFlights?.length - 1]?.arrival?.arrivalTime)?.date}</div> */}
                                            </div>
                                        </div>
                                    </div>
                                    : null}
                            </>
                        }

                    </div>
                    <div className='hw-flight--listBoxAction'>
                        {renderSeatLeftBadge()}
                        <div className="d-flex align-items-center hw-gapy10">
                            <div className="hw-text24 hw-fontBold hw-blue"> {formatePriceFn(agentActiveCurrency, formatPrice(flights?.pricing?.[0]?.totalPrice, false, true), displayPrice)}</div>
                            <button onClick={() => {
                                flightTabChangeFn(index, 'openFareViews', !flights?.openFareViews);
                                setViewFaresDataFn(flights, index)
                            }}
                                className="hw-view--pricesBtn hw-mauto--1100 hw-btn hw-btn--primaryOutline">{openFareViews ? 'Hide Prices' : "View Prices"}
                            </button>
                        </div>
                       
                        <div className="d-flex hw-xs--grow1 justify-end"><button onClick={() => {
                        flightTabChangeFn(index, 'openFlightDetails', !flights?.openFlightDetails)
                        setViewFaresDataFn(flights, index)
                    }} className="hw-xs--grow1--leftAlign hw-link hw-fontNormal hw-text14 hw-link--grayHover">
                         {openDetailsViews ? 'Hide Flight Details' : 'View Flight Details'}
                        {openDetailsViews ? <ChevronUpIcon /> :
                            <ChevronDownIcon />}</button></div>
                    </div>
                </div>
                <div className="justify-between d-flex hw-gapy10 mt-1">
                    <div className="d-flex hw-text14 hw-fontWeight--500  hw-gapy10">
                        <span>{getDateDifference(flightDetails?.returnFlights?.[0]?.departure?.departureTime, flightDetails?.returnFlights[flightDetails?.returnFlights?.length - 1]?.arrival?.arrivalTime) ? `Flight Arrives after ${getDateDifference(flightDetails?.returnFlights?.[0]?.departure?.departureTime, flightDetails?.returnFlights[flightDetails?.returnFlights?.length - 1]?.arrival?.arrivalTime)} Day` : ''}</span>
                    </div>
                </div>
            </>}
            </>
                : <>
                    <div className="hw-search--flightFilterResult__listItemList d-flex align-items-center hw-gapy10">
                        {[...new Set(flights?.segments?.map((segment) => segment?.flightCode))]?.map((flightCode, airlineIndex) => {
                            const segment = flights?.segments?.find((seg) => seg?.flightCode === flightCode); // Retrieve the corresponding segment
                            return (
                                <span key={airlineIndex} className="hw-text14 d-flex align-items-center hw-gapy10">
                                    <img
                                        width={40}
                                        height={40}
                                        src={airlineImageFn(segment?.flightCode)}
                                        alt={segment?.flightName}
                                    />
                                    <div className='d-flex d-flex-column'>
                                        <span className='hw-blue hw-fontBold hw-text--100ellipsis'>{segment?.flightName}</span>
                                        <span className='hw-text12 hw-grayk500'>{segment?.flightCode}{segment?.flightNumber}</span>
                                    </div>
                                </span>
                            );
                        })}
                        {showVendorLogo ? <div className="hw-text14 d-flex hw-gapy10 hw--vendor-img ml-auto">
                            <span className="hw-text14 hw-fontBold d-flex hw-gapy10"> {flights?.source?.replace(/-/g, '')?.replace(/^./, c => c?.toUpperCase())}</span>
                        </div> : null}
                    </div>
                    <div className="hw-flight--listBox">
                        <div className="destination s4">
                            <div className='destination-from'>

                                
                                <div
                                    className="hw-text14 hw-black900 hw-fontWeight--500">{flights?.segments[0]?.departure?.city}</div>
                                    <div className="hw-text18 hw-fontBold hw-blue">{formatDateTime(flights?.segments[0]?.departure?.departureTime)?.time}</div>
                                <div className="hw-text14 hw-black500 hw-fontWeight--500">{formatDateMonthWise(flights?.segments[0]?.departure?.departureTime)}</div>
                                {/* <div className="hw-text14">{formatDateTime(flights?.segments[0]?.departure?.departureTime)?.date}</div> */}
                            </div>
                            <div className="hw-flight--listBox__flight ">


                                <span
                                    className="hw-fontWeight--500 hw-black900">{convertMinutesFn(flights?.totalDuration)}</span>
                                <div className="hw-flight--line">
                                     {flights?.segments?.map((segement,segementIndex) => {
                                        if(segementIndex !== 0){
                                            return (
                                                <span
  className={`hw-flight--line--stop ${segementIndex === 1 ? 'hw-linestop1' : 'hw-linestopfull'}`}
 />
                                            )
                                        }
                                    })}
                                    <span className="circle" /><span className="line" /><span className="circle" />
                                    {/* <span className="hw-flight--iconFlight"><FlightIcon /></span> */}
                                </div>
                                <span
                                    className="hw-text14 hw-fontWeight--500">{flights?.segments?.length === 1 ? 'Non-Stop' : `${flights?.segments?.length - 1} stop`}</span>
                            </div>
                            <div className='destination-to'>

                                
                                <div
                                    className="hw-text14 hw-black900 hw-fontWeight--500">{flights?.segments[flights?.segments?.length - 1]?.arrival?.city}</div>
                                    <div
                                    className="hw-text18 hw-fontBold hw-blue">{formatDateTime(flights?.segments[flights?.segments?.length - 1]?.arrival?.arrivalTime)?.time}</div>
                                <div className="hw-text14 hw-black500 hw-fontWeight--500">{formatDateMonthWise(flights?.segments[flights?.segments?.length - 1]?.arrival?.arrivalTime)}</div>
                                {/* <div
                                    className="hw-text14">{formatDateTime(flights?.segments[flights?.segments?.length - 1]?.arrival?.arrivalTime)?.date}</div> */}
                            </div>
                        </div>

                        <div className="hw-flight--listBoxAction">
                            {renderSeatLeftBadge()}
                            <div className='d-flex align-items-center hw-gapy10'>
                            <div className="ss hw-xs--grow1 hw-text24 hw-xstext20 hw-fontBold hw-blue">{formatePriceFn(agentActiveCurrency, formatPrice(flights?.pricing?.[0]?.totalPrice, false,true), displayPrice)}</div>
                            <button onClick={() => {
                                flightTabChangeFn(index, 'openFareViews', !flights?.openFareViews);
                                setViewFaresDataFn(flights, index)
                            }}
                                className="hw-view--pricesBtn hw-mauto--1100 hw-btn hw-btn--primaryOutline">{openFareViews ? 'Hide Prices' : "View Prices"}
                            </button>
                            </div>
                            <div className="d-flex hw-xs--grow1 justify-end">
                                <button
                                    onClick={() => {
                                        flightTabChangeFn(index, 'openFlightDetails', !flights?.openFlightDetails);
                                        setViewFaresDataFn(flights, index);
                                    }}
                                    className="hw-xs--grow1--leftAlign hw-link hw-fontNormal hw-text14 hw-link--grayHover"

                                >
                                    {openDetailsViews ? 'Hide Flight Details' : 'View Flight Details'}
                                    {openDetailsViews ? <ChevronUpIcon /> :
                            <ChevronDownIcon />}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="justify-between d-flex hw-gapy10 w-100">
                        <div className="d-flex hw-text14 hw-fontWeight--500 hw-gapy10">
                            <span>{getDateDifference(flights?.segments[0]?.departure?.departureTime, flights?.segments[flights?.segments?.length - 1]?.arrival?.arrivalTime) ? `Flight Arrives after ${getDateDifference(flights?.segments[0]?.departure?.departureTime, flights?.segments[flights?.segments?.length - 1]?.arrival?.arrivalTime)} Day` : ''}</span>
                        </div>
                    </div>
                </>
            }

        </>
    )
}

export default FlightsShowComponent;
